import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromPaymentCheck from './payment-check.reducers';

export interface PaymentCheckState {
  stateData: fromPaymentCheck.State;
}

export interface State extends fromRoot.AppState {
  paymentCheck: PaymentCheckState;
}

export const reducers = {
  stateData: fromPaymentCheck.reducer
};

export const selectPaymentCheckState = createFeatureSelector<PaymentCheckState>('paymentCheck');

export const selectPaymentCheckStateData = createSelector(selectPaymentCheckState, (state: PaymentCheckState) => state.stateData);

// formCC
export const getFormCCForValidateState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getPendingValidateData);

export const getFormCCForUploadState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getForUploadData);

export const getFormCCSentToOeBSState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getSentOeBSData);

// formCG
export const getFormCGForValidateState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getPendingValidateFormCGData);

export const getFormCGForUploadState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getForUploadFormCGData);

export const getFormCGSentToOeBSState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getSentOeBSFormCGData);

// formPP
export const getFormPPForValidateState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getPendingValidateFormPPData);

export const getFormPPForUploadState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getForUploadFormPPData);

export const getFormPPSentToOeBSState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getSentOeBSFormPPData);

// formES
export const getFormESForValidateState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getPendingValidateFormESData);

export const getFormESForUploadState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getForUploadFormESData);

export const getFormESSentToOeBSState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getSentOeBSFormESData);

// other
export const getPaymentCheckScreenError = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getError);

export const getPaymentCheckScreenPending = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getPending);

// export const getFormCIForValidateState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getPendingValidateFormCIData);

// export const getFormCIForUploadState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getForUploadFormCIData);

// export const getFormCISentToOeBSState = createSelector(selectPaymentCheckStateData, fromPaymentCheck.getSentOeBSFormCIData);